import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/core/service/auth.service";
import { AppService } from "src/app/shared/service/app.service";
import { IdleTimeoutManager } from "idle-timer-manager";
import { ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-content-layout",
  templateUrl: "./content-layout.component.html",
  styleUrls: ["./content-layout.component.scss"],
})
export class ContentLayoutComponent implements OnInit {
  public user: any;

  title = "pro-dashboard-angular";

  public timer: any;
  public timeOut: number = 900; //expired after 15mins(here 60 sec = 1min)
  public countdown: number = 30;
  public setCountInt: any;

  @ViewChild("closeBtn", { static: true }) closeBtn;
  @ViewChild("myModalBtn", { static: true }) myModal;

  constructor(
    private appService: AppService,
    public auth: AuthService,
    public toastr: ToastrService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.user = this.auth.userValue;
    if (this.user.role == "admin") {
      this.timeOut = 3600; //expired after 3600 secs (1hr)
    }
    this.getWindowIdle();
  }

  getClasses() {
    const classes = {
      "pinned-sidebar": this.appService.getSidebarStat().isSidebarPinned,
      "toggeled-sidebar": this.appService.getSidebarStat().isSidebarToggeled,
    };
    return classes;
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }

  public openModal() {
    this.myModal.nativeElement.click();
  }

  public modalClose() {
    this.closeBtn.nativeElement.click(); // call modal close button
  }

  getWindowIdle() {
    this.timer = new IdleTimeoutManager({
      timeout: this.timeOut, // expire time
      onExpired: () => {
        this.openModal();
        this.setCountInt = setInterval(() => {
          this.countdown = this.countdown - 1;
          if (this.countdown == 0) {
            this.logout();
          }
        }, 1000);
      },
    });
  }

  resetIdle() {
    this.countdown = 30;
    this.modalClose();
    this.timer.clear();
    this.getWindowIdle();
  }

  stay() {
    clearInterval(this.setCountInt);
    this.resetIdle();
  }

  logout() {
    clearInterval(this.setCountInt);
    this.modalClose();
    this.timer.clear();
    this.authService.logoutWithReload();
    this.toastr.success("You were Logged Out!", "Success", { timeOut: 2000 });
  }

  ngOnDestroy() {
    if (this.timer) {
      this.timer.clear();
      this.modalClose();
    }
  }
}
